import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0bae78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-4" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-4 wrapper-button" }
const _hoisted_4 = {
  key: 1,
  class: "d-lg-flex"
}
const _hoisted_5 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "ms-1 badge bg-green"
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_9 = { class: "text-break" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "align-middle text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen color-edit" }, null, -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "text-center fw-bold"
}
const _hoisted_17 = {
  key: 4,
  class: "d-lg-flex"
}
const _hoisted_18 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_19 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "modal-dialog" }
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_25 = { class: "text-center py-4" }
const _hoisted_26 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_29 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_30 = {
  class: "modal fade",
  id: "modalSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "modal-dialog" }
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = { class: "modal-header" }
const _hoisted_34 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_36 = { class: "text-center py-4" }
const _hoisted_37 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-lg-12 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }

import Button from '@/components/button/index.vue'
import { computed, onMounted, ref, watch } from 'vue'
import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
// import CellSort from '@/components/cell-sort/index.vue'
import { translate } from '@/languages/i18n'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Table from '@/components/table/index.vue'
import Loading from '@/components/loading/index.vue'

import messageTemplateServices from '@/services/message-template.services'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import TotalRecords from '@/components/total-records/index.vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route?.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('messageManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('CE10breadcrumb2'),
    to: '',
    active: true,
  },
]

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const loading = ref(false)

const currentTemplateId = ref<number>()
const currentTemplateName = ref<string>('')
const deleteFailed = ref<boolean>(false)
const setCurrentId = (id: number, name: string): void => {
  currentTemplateId.value = id
  currentTemplateName.value = name
}

// 2022/09/12 TienNV Fix double click button confirm
const loadingButton = ref(false)
const modalConfirm = ref()
const modalSuccess = ref()
const store = useStore()
const dataMessageTemplate = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.LIST_MESSAGE_TEMPLATES]?.listMessageTemplates)

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
  modalSuccess.value = new Modal(document.getElementById('modalSuccess'))
})

const handleDelete = async (): void => {
  // 2022/09/12 TienNV Fix double click button confirm
  loadingButton.value = true
  try {
    if (route.params?.id && currentTemplateId.value) {
      const res = await messageTemplateServices.deleteMessageTemplatesById(route.params.id, currentTemplateId.value)
      if (res.data?.success) {
        store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_MESSAGE_TEMPLATES, {
          id: route?.params?.id,
          params: {
            ...route.query,
            page: route?.query?.page || 1,
            page_of_number: route?.query?.page_of_number || 30,
          },
        })
        deleteFailed.value = false
      } else {
        deleteFailed.value = true
      }
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        loadingButton.value = false
      }, 2000)
    }
  } catch (error) {
    modalConfirm.value.hide()
    modalSuccess.value.show()
    deleteFailed.value = false
    loadingButton.value = false
    console.log(error)
  }
}

watch(
  () => route.query,
  async () => {
    store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_MESSAGE_TEMPLATES, {
      id: route?.params?.id,
      params: {
        ...route.query,
        page: route?.query?.page || 1,
        page_of_number: route?.query?.page_of_number || 30,
      },
    })
  },
  {
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CE10breadcrumb2')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "message_templates/new",
          class: "text-black border rounded-pill text-decoration-none px-4 py-2 bg-white shadow button-router-link fs-75"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('CE10signUp')), 1)
          ]),
          _: 1
        })
      ]),
      (!loading.value)
        ? (_openBlock(), _createBlock(TotalRecords, {
            key: 0,
            totalRecords: _unref(dataMessageTemplate)?.total_records
          }, null, 8, ["totalRecords"]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalPage: _unref(dataMessageTemplate)?.total_pages,
                totalDataOfPage: _unref(dataMessageTemplate)?.data?.length
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createBlock(Table, {
            key: 2,
            columns: [
        { field: 'name', name: _unref(translate)('templateName'), sort: _ctx.sortField === 'name' },
        { field: 'management_no', name: _unref(translate)('managementNo'), sort: _ctx.sortField === 'management_no' },
        { field: 'full_name', name: _unref(translate)('registrants'), sort: _ctx.sortField === 'full_name' },
        { field: 'created_at', name: _unref(translate)('registrationDate'), sort: _ctx.sortField === 'created_at', defaultSort: 'desc' },
        { field: 'edit', name: _unref(translate)('edit') },
        { field: 'delete', name: _unref(translate)('delete') },
      ],
            sortCells: ['name', 'management_no', 'full_name', 'created_at']
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataMessageTemplate)?.data, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass({ rowEven: index % 2 === 0 }),
                  key: index
                }, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.name || '-') + " ", 1),
                    (item?.message_type === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.management_no || '-'), 1),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(UserAliasIcon, {
                      userType: item?.user_type || 3
                    }, null, 8, ["userType"]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.family_name) + " " + _toDisplayString(item.given_name), 1)
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(ConvertFromLocalTime)(item.created_at) || '-'), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: `message_templates/${item.id}/edit`,
                      class: "color-edit"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (setCurrentId(item.id, item.name)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalConfirm",
                    class: "cursor-pointer align-middle text-center"
                  }, _hoisted_15, 8, _hoisted_13)
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["columns"]))
        : _createCommentVNode("", true),
      (!_unref(dataMessageTemplate)?.data?.length && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('CC10noData')), 1))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalPage: _unref(dataMessageTemplate)?.total_pages,
                totalDataOfPage: _unref(dataMessageTemplate)?.data?.length
              }, null, 8, ["totalPage", "totalDataOfPage"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h5", _hoisted_23, _toDisplayString(_unref(translate)('titleMessageTemplate')), 1),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, "「" + _toDisplayString(currentTemplateName.value) + "」" + _toDisplayString(_unref(translate)('deleteText')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  dataBsToggle: 'modal',
                  dataBsTarget: '#modal'
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(Button, {
                  title: _unref(translate)('deleteButton'),
                  type: 'secondary',
                  onClick: handleDelete,
                  loading: loadingButton.value,
                  disabled: loadingButton.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("h5", _hoisted_34, _toDisplayString(_unref(translate)('titleMessageTemplate')), 1),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, _toDisplayString(deleteFailed.value ? _unref(translate)('CE10deleteFailed') : _unref(translate)('deleteSuccess')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(Button, {
                  title: _unref(translate)('close'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})